import { ExpressPaymentMethodStatus } from '../../models/expressCheckout';
import { CheckoutState } from '../../state';
import {
    areExpressCheckoutConditionsLoaded,
    isGooglePayAvailableAsExpressPaymentMethod,
} from '../expressCheckoutConditions';
import { getGooglePayInstance } from './pureSelectors';

export const getGooglePayExpressPaymentMethodStatus = (
    state: CheckoutState,
) => {
    if (!areExpressCheckoutConditionsLoaded(state)) {
        return ExpressPaymentMethodStatus.availabilityNotEvaluatedYet;
    }

    if (!isGooglePayAvailableAsExpressPaymentMethod(state)) {
        return ExpressPaymentMethodStatus.unavailable;
    }

    return getGooglePayInstance(state)
        ? ExpressPaymentMethodStatus.fullyLoaded
        : ExpressPaymentMethodStatus.loadingScripts;
};
